import React from 'react';
import './Header.scss';
import LOGO from '../assets/wolte_logo.png';
import NotificationsIcon from '@mui/icons-material/Notifications';

const Header = ({ toggleMenu, toggleNotifications, isNotificationUnread }) => {
  return (
    <div className='Header'>
      <div className='left'>
        <img src={LOGO} className='logo' alt='logo' />
      </div>
      <div className='right'>
        <div className='notificationsButton' onClick={toggleNotifications}>
          <NotificationsIcon className='notificationsIcon' />
          {isNotificationUnread && (
            <div className='notificationUnreadIndicator'/>
          )}
        </div>
        <div className='menuButton' onClick={toggleMenu}>
          <div className='menuButtonBar' />
          <div className='menuButtonBar' />
          <div className='menuButtonBar' />
        </div>
      </div>
    </div>
  )
};

export default Header;
